export interface Listing {
  id: number;
  address: string;
  city: string;
  state: string;
  zip: string;
  price: number;
  beds: number;
  baths: number;
  sqft: number;
  type: string;
  status: 'For Sale' | 'Under Contract' | 'Sold';
  image: string;
  description: string;
}

export const listings: Listing[] = [
  {
    id: 1,
    address: '3245 Peachtree Corners Circle',
    city: 'Duluth',
    state: 'GA',
    zip: '30096',
    price: 689000,
    beds: 4,
    baths: 3,
    sqft: 2850,
    type: 'Single Family',
    status: 'For Sale',
    image: 'https://public.readdy.ai/ai/img_res/da20961c35b1063960dde93e774438f9.jpg',
    description: 'Stunning colonial home in a sought-after Duluth neighborhood. Open floor plan, gourmet kitchen, and a spacious backyard perfect for entertaining.',
  },
  {
    id: 2,
    address: '5812 Settles Bridge Road',
    city: 'Suwanee',
    state: 'GA',
    zip: '30024',
    price: 825000,
    beds: 5,
    baths: 4,
    sqft: 3620,
    type: 'Single Family',
    status: 'For Sale',
    image: 'https://readdy.ai/api/search-image?query=elegant%20craftsman%20style%20house%20with%20stone%20facade%20covered%20front%20porch%20green%20manicured%20landscaping%20Suwanee%20Georgia%20residential%20neighborhood%20warm%20afternoon%20golden%20hour%20real%20estate%20listing%20photo&width=800&height=560&seq=listing2&orientation=landscape',
    description: 'Luxurious craftsman home in the top-rated Suwanee school district. Master suite on main, chef\'s kitchen, three-car garage.',
  },
  {
    id: 3,
    address: '1450 Windmill Pkwy',
    city: 'Duluth',
    state: 'GA',
    zip: '30097',
    price: 455000,
    beds: 3,
    baths: 2,
    sqft: 1980,
    type: 'Townhome',
    status: 'Under Contract',
    image: 'https://readdy.ai/api/search-image?query=modern%20townhouse%20row%20with%20brick%20and%20siding%20exterior%20attached%20garage%20neat%20landscaping%20Georgia%20suburban%20community%20bright%20daylight%20real%20estate%20professional%20photography%20clean%20sky&width=800&height=560&seq=listing3&orientation=landscape',
    description: 'Move-in ready townhome in Duluth\'s vibrant community. Updated kitchen, hardwood floors, and a private patio.',
  },
  {
    id: 4,
    address: '770 Peachtree Industrial Blvd',
    city: 'Suwanee',
    state: 'GA',
    zip: '30024',
    price: 1250000,
    beds: 0,
    baths: 2,
    sqft: 5400,
    type: 'Commercial',
    status: 'For Sale',
    image: 'https://readdy.ai/api/search-image?query=modern%20commercial%20office%20building%20with%20glass%20facade%20clean%20professional%20exterior%20parking%20lot%20Atlanta%20Georgia%20metro%20area%20business%20district%20clear%20blue%20sky%20professional%20real%20estate%20photo&width=800&height=560&seq=listing4&orientation=landscape',
    description: 'Prime commercial property in a high-traffic Suwanee corridor. Ideal for retail, medical, or professional offices.',
  },
  {
    id: 5,
    address: '2988 Club Drive NE',
    city: 'Atlanta',
    state: 'GA',
    zip: '30319',
    price: 1480000,
    beds: 6,
    baths: 5,
    sqft: 5100,
    type: 'Single Family',
    status: 'For Sale',
    image: 'https://readdy.ai/api/search-image?query=luxury%20modern%20white%20stucco%20estate%20home%20with%20iron%20gate%20fountain%20driveway%20lush%20landscaping%20Atlanta%20Georgia%20affluent%20neighborhood%20bright%20sunshine%20professional%20real%20estate%20photography&width=800&height=560&seq=listing5&orientation=landscape',
    description: 'Magnificent estate home in prestigious Buckhead area. Smart home features, resort-style pool, and a home theater.',
  },
  {
    id: 6,
    address: '4110 River Green Pkwy',
    city: 'Duluth',
    state: 'GA',
    zip: '30096',
    price: 565000,
    beds: 4,
    baths: 3,
    sqft: 2450,
    type: 'Single Family',
    status: 'Sold',
    image: 'https://readdy.ai/api/search-image?query=charming%20traditional%20american%20house%20with%20beige%20siding%20shutters%20front%20porch%20swing%20fall%20foliage%20trees%20Duluth%20Georgia%20quiet%20residential%20street%20real%20estate%20photo%20natural%20light%20no%20people&width=800&height=560&seq=listing6&orientation=landscape',
    description: 'Charming home backing up to River Green\'s amenities. Updated bathrooms, large deck, and top-rated school district.',
  },
];
